import axiosInstance from "./AxiosInstance";
export function busoccupancyreport(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_occupancy_report?${fparam}`
  );
}
export const busoccupancyreportdownload = (param) => {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_occupancy_report?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function utilizationreport(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_utilization_report?${fparam}`
  );
}
export const utilizationreportdownload = (param) => {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_utilization_report?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function popularstopreport(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/reports/popular_stops?${fparam}`);
}
export const popularstopreportdownload = (param) => {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/reports/popular_stops?${fparam}`, {
    responseType: "blob",
  });
};
export function genderdistributionreport(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/gender_distribution?${fparam}`
  );
}
export const genderdistributionreportdownload = (param) => {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/gender_distribution?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function searchshift() {
  return axiosInstance.get("api/transport/search-shift");
}
export function searchroute() {
  return axiosInstance.get("api/transport/search-route");
}
export function getbusarrivalreport(param={}) {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(`api/transport/reports/bus_arrival_report?${fparam}`);
}
export function getdriverreport(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/bus_pickup_employees?${fparam}`);
}
export function getbusarrivaldetails(id,param={}) {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/bus_arrival_detail_report/${id}?${fparam}`
  );
}
export const driverreportdownloadexcel = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/bus_pickup_employees?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getboardinglog(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/boarding_history?${fparam}`);
}
export const getboardinglogexport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/boarding_history?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getexceptionreport(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/exception_report?${fparam}`);
}
export const getexceptionreportexport = (param) => {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/exception_report?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function gettravelhistory(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/bus_travel_history?${fparam}`);
}
export const gettravelhistortyexport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/bus_travel_history?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getauditlog(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/audit_log_report?${fparam}`);
}
export const getauditlogexport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/audit_log_report?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getStopReport(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/reports/stop_log?${fparam}`);
}
export const getStopReportExport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/reports/stop_log?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getBusTravelLog(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/buses/travel-reports/?${fparam}`);
}
export const getBusTravelLogExport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/buses/travel-reports/?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getReplaceLog(parama={}) {
  const fparam=new URLSearchParams(parama).toString()
  return axiosInstance.get(`api/transport/all_bus_replace_log?${fparam}`);
}
export const getReplaceLogExport = (param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/all_bus_replace_log?${fparam}`,
    {
      responseType: "blob",
    }
  );
};